import type { TranslationModule } from '../types';

export const roiTranslations: TranslationModule = {
  ro: {
    seo: {
      title: "Raport ROI - Investește în Viitorul Juridic Românesc | LegeaAplicata",
      desc: "Descoperă impactul măsurabil al LegeaAplicata.ro: creșteri de productivitate de până la 94%, economii de ore facturabile, câștig de clienți noi. Platforma AI juridică nr. 1 din România.",
      keywords: "ROI juridic, investiție legaltech România, AI juridic roi, LegeaAplicata investitori, platformă juridică AI, productivitate avocați, eficiență juridică",
      schemaTitle: "Raport ROI - LegeaAplicata.ro",
      schemaDesc: "Raport complet privind impactul și randamentul investiției în platforma juridică LegeaAplicata.ro"
    },
    hero: {
      badge: "Raport ROI 2025",
      line1: "Investiția în ",
      highlight1: "InteligenȚă",
      line2: "",
      highlight2: "Juridică",
      subtitle: "Cum LegeaAplicata.ro transformă practica juridică românească prin inteligență artificială — cu rezultate măsurabile.",
      subtitleFounder: "Platforma de cercetare juridică asistată de tehnologie din România, dezvoltată de Adrian Nicolau — fondator și dezvoltator software — pentru a eficientiza documentarea în legislație și jurisprudență.",
      btnContact: "Contactează-ne",
      btnResults: "Vezi Rezultatele"
    },
    intro: {
      badge: "Metodologie",
      title: "Despre Acest Raport",
      desc1: "Raportul de față cuantifică impactul real al LegeaAplicata.ro în practica juridică românească, pornind de la date colectate de la cabinete de avocatură, birouri de consilieri juridici și instituții publice care utilizează platforma.",
      desc2: "Industria juridică traversează cea mai profundă transformare din ultima generație. Firmele care au adoptat timpuriu instrumentele AI înregistrează acum randamente tangibile — iar datele din acest raport oferă un cadru credibil pentru ceea ce liderii din drept pot anticipa.",
      stat1Val: "200+",
      stat1Label: "Utilizatori Activi",
      stat1Sub: "Avocați, consilieri, magistrați",
      stat2Val: "8+",
      stat2Label: "Județe Acoperite",
      stat2Sub: "Prezență în toată România",
      stat3Val: "2024",
      stat3Label: "Fondată",
      stat3Sub: "Platformă în continuă creștere"
    },
    finding1: {
      badge: "Constatarea Cheie 1",
      title: "Impactul asupra ",
      highlight: "Veniturilor",
      desc: "Câștigurile de productivitate sunt universale. Fiecare utilizator al platformei a raportat beneficii concrete și cuantificabile.",
      mainStatPct: "94%",
      mainStatTitle: "Răspund mai rapid clienților și partenerilor",
      mainStatDesc: "Pe o scală de la 1 la 5, 94% din utilizatori confirmă că pot răspunde la solicitări mai rapid (4) sau mult mai rapid (5) folosind LegeaAplicata.ro. Câștigurile de productivitate sunt universale — fiecare utilizator poate oferi exemple concrete de dosare rezolvate mai eficient.",
      examplesHeader: "Exemple concrete",
      ex1: "Revizuirea a 500 de hotărâri judecătorești redusă de la săptămâni la zile",
      ex2: "Căutarea jurisprudenței relevante: de la 5h/zi la 30 min",
      ex3: "Generare primă variantă cereri de chemare în judecată: 60% mai rapid",
      ex4: "Analiză comparativă pe 7 dosare similare realizată în ore, nu zile",
      statCard1: {
        label: "Capacitate de lucru extinsă",
        sub: "Mai multe dosare în același interval de timp"
      },
      statCard2: {
        label: "Sarcini care dura ore → minute",
        sub: "Timp economisit pentru muncă facturabilă"
      },
      statCard3: {
        label: "Ore non-facturabile recuperate/săptămână",
        sub: "Per utilizator, în medie"
      },
      statCard4: {
        label: "Reducere ore non-facturabile",
        sub: "Confirmat de utilizatorii activi"
      },
      calcTitle: "Calculul Potenţialului de Venituri Suplimentare",
      calcSub: "Bazat pe 4.3 ore recuperate pe săptămână per jurist, la tariful mediu orar din România",
      calcCol1Title: "Ore recuperate/an per jurist",
      calcCol1Sub: "~198 (4.3h × 46 săptămâni)",
      calcCol2Title: "Tarif orar mediu avocat (RON)",
      calcCol2Sub: "400 (mediu piața românească)",
      calcCol3Title: "Venituri potențiale extra/an per jurist",
      calcCol3Sub: "~79.200 RON (la 100 juriști: ~7.9M RON/an)",
      calcFormula: "Formula ROI: Nr. juriști × Ore economisit/săptămână × Tarif orar × 46 săptămâni",
      whoBenefitsTitle: "Cine beneficiază cel mai mult?",
      whoBenefitsL1: "Avocați cu experiență medie (2-7 ani)",
      whoBenefitsL2: "Avocați seniori / asociați",
      whoBenefitsL3: "Juniori / stagiari",
      whoBenefitsL4: "Parteneri / asociați fondatori",
      reallocTitle: "Cum este realocate timpul economisit?",
      reallocL1: "Analiză juridică de valoare superioară",
      reallocL2: "Interacțiune sporită cu clienții",
      reallocL3: "Muncă facturabilă suplimentară",
      reallocL4: "Dezvoltare afaceri noi"
    },
    testimonials: {
      badge: "Vocea Clienților",
      title: "Ce spun practicienii în drept",
      q1Text: "LegeaAplicata.ro mi-a schimbat complet modul de lucru. Ceea ce înainte îmi lua o zi întreagă în biblioteca de doctrină acum rezolv în 30 de minute. Am putut să preiau două dosare în plus luna trecută.",
      q1Author: "Av. M. Ionescu",
      q1Role: "Avocat drept civil, București",
      q2Text: "Am folosit platforma pentru analiza comparată a 47 de hotărâri ICCJ pe același subiect. Calitatea sintezei AI a depășit orice așteptare. Clientul a fost impresionat de viteza de răspuns.",
      q2Author: "Av. C. Popescu",
      q2Role: "Partener cabinet avocat, Cluj-Napoca",
      q3Text: "Ca jurist de companie, trebuie să monitorizez dosare din toată țara. LegeaAplicata.ro face asta automat și îmi trimite alerte. Nu mai ratez niciun termen.",
      q3Author: "C.J. A. Dumitrescu",
      q3Role: "Consilier juridic, Timișoara",
      q4Text: "Instrumentul de generare documente m-a ajutat să finalizez 3 contracte complexe în jumătate din timp. Clienții observă viteza și continuă să revină.",
      q4Author: "Av. R. Constantin",
      q4Role: "Cabinet independent, Iași",
      q5Text: "La un cabinet cu 8 avocați, adopția LegeaAplicata.ro a adus o economie de timp estimată la 35% per dosar. Am putut să refuzăm zero dosare în ultima lună, față de 3 lunar înainte.",
      q5Author: "Av. D. Gheorghiu",
      q5Role: "Managing Partner, Brașov",
      q6Text: "Platforma identifică probleme pe care le-aș fi ratat altfel. M-a ajutat să câștig un dosar de muncă în care inamicul adversarului era o prevedere din Codul Fiscal pe care nu o asociasem cu speța.",
      q6Author: "Av. L. Marin",
      q6Role: "Dreptul muncii și drept comercial"
    },
    finding2: {
      badge: "Constatarea Cheie 2",
      title: "Impactul asupra ",
      highlight: "Calității",
      desc: "Dincolo de productivitate, AI-ul juridic ridică standardul calitativ al lucrărilor și reduce riscul erorii umane.",
      card1: {
        label: "Identifică probleme ratate anterior",
        desc: "AI-ul detectează aspecte juridice pe care practicienii le-ar fi omis în analiza manuală"
      },
      card2: {
        label: "Mai multă încredere în calitatea lucrărilor",
        desc: "Juriștii raportează că se simt mai siguri în opiniile și documentele redactate cu suportul AI"
      },
      card3: {
        label: "Impact mare sau transformațional asupra calității",
        desc: "Reducerea riscului de erori, identificarea problemelor timpuriu și management superior al riscului"
      },
      talentBadge: "Elevarea Talentului",
      talentTitle: "AI-ul juridic amplifică performanța profesioniștilor de top",
      talentDesc: "Pentru profesioniștii cu performanțe ridicate, LegeaAplicata.ro oferă un avantaj considerabil. 65% dintre utilizatori raportează o îmbunătățire semnificativă a performanței personale. AI-ul funcționează cel mai bine pentru cei care știu deja ce caută — și le dă resurse să scaleze.",
      talentQuote: "\"LegeaAplicata.ro este pentru avocați ceea ce Google Maps este pentru șoferi — nu înlocuiește expertiza, ci o potențează.\"",
      talentL1: "Profesioniști cu performanțe ridicate",
      talentL2: "Îmbunătățire echipă în ansamblu",
      talentL3: "Scriere mai clară și comunicare îmbunătățită",
      talentL4: "Capacitate de analiză mai profundă"
    },
    finding3: {
      badge: "Constatarea Cheie 3",
      title: "Impactul pe ",
      highlight: "Termen Lung",
      desc: "Valoarea pe termen lung a AI-ului juridic crește odată cu maturizarea ecosistemului și buildarea de cunoaștere instituțională.",
      card1: "61% - Impact mare sau transformațional în dezvoltarea competențelor AI",
      card2: "87% - Clienții îi văd mai pozitiv datorită adoptării AI juridic modern",
      card3: "55% - Platforma a înlocuit sau redus nevoia de alte instrumente",
      advantageTitle: "Avantajul Competitiv",
      advantage1: "48% consideră că LegeaAplicata.ro îi diferențiază față de concurență",
      advantage2: "42% au câștigat noi clienți sau contracte datorită adoptării AI juridic",
      advantage3: "77% citează AI-ul când explică viteza de răspuns și valoarea oferită clienților",
      advantage4: "39% livrează mai ușor contracte la prețuri fixe, eliminând incertitudinea",
      advantage5: "52% confirma că platforma a extins relațiile cu clienții existenți",
      disappearTitle: "Dacă platforma ar dispărea mâine...",
      disappearL1: "Perturbator major — deja integrat în fluxul de lucru zilnic",
      disappearL2: "Perturbator gestionabil — reconstrucția ar lua timp",
      disappearL3: "Inconfortabil — alternativele sunt inferioare",
      disappearQuote: "\"Ar fi extrem de perturbator; avem o viteză de răspuns pe care nu o mai putem susţine fără AI. Unele tipuri de mandate nu ar mai putea fi acceptate la preț fix.\"",
      disappearAuthor: "— Partener cabinet avocat, utilizator LegeaAplicata"
    },
    features: {
      badge: "Platforma",
      title: "Ce oferă LegeaAplicata.ro",
      sub: "Un ecosistem juridic complet, construit special pentru realitățile sistemului de drept românesc",
      f1Title: "Jurisprudență AI",
      f1Desc: "Baza de date cu mii de hotărâri judecătorești ICCJ, CEDO și instanțe românești, cu căutare semantică avansată",
      f2Title: "Analiză Comparativă",
      f2Desc: "Analiză paralelă a mai multor hotărâri pe același subiect, cu identificare automată a tendințelor",
      f3Title: "Monitoring Dosare",
      f3Desc: "Urmărire automată a dosarelor la instanță, notificări în timp real pentru termene și actualizări",
      f4Title: "Chat AI Juridic",
      f4Desc: "Asistent AI specializat pe legislație și jurisprudență română, disponibil 24/7",
      f5Title: "Bonitate Societăți",
      f5Desc: "Verificare situației financiare și juridice a societăților comerciale din România",
      f6Title: "Generare Documente",
      f6Desc: "Generare semi-automată a cererilor, contractelor și altor documente juridice standardizate"
    },
    founder: {
      badge: "Viziunea Fondatorului",
      titleLine: "De ce am construit ",
      titleHighlight: "LegeaAplicata.ro",
      quote: "\"Misiunea mea este să transform accesul la justiție prin tehnologie. LegeaAplicata.ro nu este doar o bază de date — este un partener digital pentru fiecare avocat și justițiabil din România.\"",
      desc: "Combinând studiile în drept cu competențe avansate în inginerie software, Adrian Nicolau a conceput LegeaAplicata.ro ca un instrument tehnologic de cercetare și documentare, menit să elimine orele de căutare manuală prin legislație și jurisprudență."
    },
    market: {
      badge: "Oportunitatea de Piață",
      title: "O piață vastă, insuficient deservită",
      card1: {
        label: "Avocați activi în România",
        sub: "Sursă: UNBR 2024"
      },
      card2: {
        label: "Consilieri juridici",
        sub: "Piață adiacentă"
      },
      card3: {
        label: "Magistrați și judecători",
        sub: "Potențiali utilizatori"
      },
      card4: {
        label: "Piața serviciilor juridice RO",
        sub: "Potențial de digitalizare ≥ 30%"
      },
      growthTitle: "Traiectoria de Creștere",
      growthDesc: "Sectorul LegalTech global crește cu ~22% CAGR. România, cu un sistem juridic complex și o comunitate de practicieni bine pregătiți, este o piață cu potențial enorm — și LegeaAplicata.ro este deja platformă de referință.",
      growthP1: "Prima platformă AI juridică specializată pe legislație română",
      growthP2: "Creștere organică prin recomandări între practicieni",
      growthP3: "Model freemium → conversie premium validat",
      growthP4: "Prezență media și recunoaștere în comunitatea juridică",
      penetrationLabel: "Penetrare actuală piață avocați",
      penetrationSub: "Spațiu enorm de creștere — țintă 10% în 3 ani",
      targetTitle: "Țintă 2027",
      targetL1: "utilizatori activi",
      targetL2: "venituri recurente anuale"
    },
    conclusion: {
      badge: "Concluzie",
      titleLine: "Viitorul practicii juridice ",
      titleHighlight: "este deja prezent",
      desc1: "Câștigurile de productivitate sunt avantajul principal al adoptării AI juridic, urmate rapid de îmbunătățiri ale performanței, creșterea calității și creșterea veniturilor. Datele arată că timpul economisit se transformă tot mai mult în productivitate crescută și noi oportunități de afaceri.",
      desc2: "Pentru clienții noștri, LegeaAplicata.ro este o parte esențială a creșterii lor. Dacă ar dispărea, 81% ar experimenta perturbări majore sau semnificative. Aceasta este definiția unei soluții cu adevărat valoroase.",
      stat1: "Răspund mai rapid clienților",
      stat2: "Capacitate extinsă",
      stat3: "Percepție pozitivă de la clienți",
      stat4: "Impact transformațional pe calitate",
      ctaTitle: "Investește în Viitorul Juridicului Românesc",
      ctaDesc: "Discută direct cu echipa fondatoare despre oportunități de parteneriat, investiție sau colaborare strategică.",
      ctaBtn: "Contactează Echipa"
    }
  },
  en: {
    seo: {
      title: "ROI Report - Invest in the Romanian Legal Future | LegeaAplicata",
      desc: "Discover the measurable impact of LegeaAplicata.ro: productivity gains up to 94%, billable hours savings, new client acquisition. The #1 AI legal platform in Romania.",
      keywords: "legal ROI, legaltech investment Romania, AI legal roi, LegeaAplicata investors, AI legal platform, lawyer productivity, legal efficiency",
      schemaTitle: "ROI Report - LegeaAplicata.ro",
      schemaDesc: "Comprehensive report on the impact and return on investment of the LegeaAplicata.ro legal platform"
    },
    hero: {
      badge: "ROI Report 2025",
      line1: "Investing in ",
      highlight1: "Legal",
      line2: "",
      highlight2: "Intelligence",
      subtitle: "How LegeaAplicata.ro transforms Romanian legal practice through artificial intelligence — with measurable results.",
      subtitleFounder: "The legal research technology platform in Romania, built by Adrian Nicolau — founder and software developer — to streamline research in legislation and case law.",
      btnContact: "Contact Us",
      btnResults: "See Results"
    },
    intro: {
      badge: "Methodology",
      title: "About This Report",
      desc1: "This report quantifies the real impact of LegeaAplicata.ro in Romanian legal practice, based on data collected from law firms, legal advisor offices, and public institutions using the platform.",
      desc2: "The legal industry is undergoing its deepest transformation in a generation. Early adopters of AI tools are now seeing tangible returns — and the data in this report provides a credible framework for what legal leaders can expect.",
      stat1Val: "200+",
      stat1Label: "Active Users",
      stat1Sub: "Lawyers, advisors, magistrates",
      stat2Val: "8+",
      stat2Label: "Counties Covered",
      stat2Sub: "Presence throughout Romania",
      stat3Val: "2024",
      stat3Label: "Founded",
      stat3Sub: "Continuously growing platform"
    },
    finding1: {
      badge: "Key Finding 1",
      title: "Impact on ",
      highlight: "Revenue",
      desc: "Productivity gains are universal. Every user of the platform reported concrete and quantifiable benefits.",
      mainStatPct: "94%",
      mainStatTitle: "Faster response times to clients and partners",
      mainStatDesc: "On a scale of 1 to 5, 94% of users confirm they can respond to requests faster (4) or much faster (5) using LegeaAplicata.ro. Productivity gains are universal — every user can provide concrete examples of cases resolved more efficiently.",
      examplesHeader: "Concrete Examples",
      ex1: "Reviewing 500 court rulings reduced from weeks to days",
      ex2: "Relevant case law search: from 5h/day to 30 mins",
      ex3: "Generating initial draft of court summons: 60% faster",
      ex4: "Comparative analysis of 7 similar cases completed in hours, not days",
      statCard1: {
        label: "Expanded Work Capacity",
        sub: "More cases in the same timeframe"
      },
      statCard2: {
        label: "Tasks taking hours → minutes",
        sub: "Time saved for billable work"
      },
      statCard3: {
        label: "Non-billable hours recovered/week",
        sub: "Per user, on average"
      },
      statCard4: {
        label: "Non-billable hours reduction",
        sub: "Confirmed by active users"
      },
      calcTitle: "Calculation of Additional Revenue Potential",
      calcSub: "Based on 4.3 hours recovered per week per jurist, at the average hourly rate in Romania",
      calcCol1Title: "Hours recovered/year per jurist",
      calcCol1Sub: "~198 (4.3h × 46 weeks)",
      calcCol2Title: "Average lawyer hourly rate (RON)",
      calcCol2Sub: "400 (Romanian market average)",
      calcCol3Title: "Potential extra revenue/year per jurist",
      calcCol3Sub: "~79,200 RON (for 100 jurists: ~7.9M RON/year)",
      calcFormula: "ROI Formula: Number of jurists × Hours saved/week × Hourly rate × 46 weeks",
      whoBenefitsTitle: "Who benefits the most?",
      whoBenefitsL1: "Lawyers with mid-level experience (2-7 years)",
      whoBenefitsL2: "Senior lawyers / associates",
      whoBenefitsL3: "Juniors / trainees",
      whoBenefitsL4: "Partners / founding associates",
      reallocTitle: "How is the saved time reallocated?",
      reallocL1: "Higher-value legal analysis",
      reallocL2: "Increased client interaction",
      reallocL3: "Additional billable work",
      reallocL4: "New business development"
    },
    testimonials: {
      badge: "Voice of the Clients",
      title: "What legal practitioners are saying",
      q1Text: "LegeaAplicata.ro has completely changed my way of working. What used to take me a whole day in the doctrine library is now resolved in 30 minutes. I was able to take on two extra cases last month.",
      q1Author: "M. Ionescu, Esq.",
      q1Role: "Civil law attorney, Bucharest",
      q2Text: "I used the platform for a comparative analysis of 47 ICCJ rulings on the same topic. The quality of the AI summary exceeded all expectations. The client was impressed by the response speed.",
      q2Author: "C. Popescu, Esq.",
      q2Role: "Law firm partner, Cluj-Napoca",
      q3Text: "As an in-house counsel, I need to monitor cases nationwide. LegeaAplicata.ro does this automatically and sends me alerts. I never miss a deadline.",
      q3Author: "A. Dumitrescu, Legal Advisor",
      q3Role: "Legal Advisor, Timisoara",
      q4Text: "The document generation tool helped me finalize 3 complex contracts in half the time. Clients notice the speed and keep coming back.",
      q4Author: "R. Constantin, Esq.",
      q4Role: "Independent practice, Iasi",
      q5Text: "At a firm with 8 lawyers, the adoption of LegeaAplicata.ro brought an estimated time savings of 35% per case. We were able to refuse zero cases last month, compared to 3 monthly before.",
      q5Author: "D. Gheorghiu, Esq.",
      q5Role: "Managing Partner, Brasov",
      q6Text: "The platform identifies issues I would have otherwise missed. It helped me win an employment case where the key argument was a Fiscal Code provision I hadn't associated with the matter.",
      q6Author: "L. Marin, Esq.",
      q6Role: "Labor & Commercial Law"
    },
    finding2: {
      badge: "Key Finding 2",
      title: "Impact on ",
      highlight: "Quality",
      desc: "Beyond productivity, legal AI raises the quality standard of work and reduces the risk of human error.",
      card1: {
        label: "Identifies previously missed issues",
        desc: "AI detects legal aspects that practitioners might have omitted in manual analysis"
      },
      card2: {
        label: "Greater confidence in work quality",
        desc: "Jurists report feeling more confident in opinions and documents drafted with AI support"
      },
      card3: {
        label: "High or transformational impact on quality",
        desc: "Reduced error risk, early issue identification, and superior risk management"
      },
      talentBadge: "Talent Elevation",
      talentTitle: "Legal AI amplifies the performance of top professionals",
      talentDesc: "For high-performing professionals, LegeaAplicata.ro offers a considerable advantage. 65% of users report a significant improvement in personal performance. AI works best for those who already know what they are looking for — and gives them the resources to scale.",
      talentQuote: "\"LegeaAplicata.ro is to lawyers what Google Maps is to drivers — it doesn't replace expertise, it powers it.\"",
      talentL1: "High-performing professionals",
      talentL2: "Overall team improvement",
      talentL3: "Clearer writing and improved communication",
      talentL4: "Deeper analytical capacity"
    },
    finding3: {
      badge: "Key Finding 3",
      title: "Long-term ",
      highlight: "Impact",
      desc: "The long-term value of legal AI grows as the ecosystem matures and institutional knowledge is built.",
      card1: "61% - High or transformational impact on AI skills development",
      card2: "87% - Clients view them more positively due to adopting modern legal AI",
      card3: "55% - The platform replaced or reduced the need for other tools",
      advantageTitle: "Competitive Advantage",
      advantage1: "48% feel that LegeaAplicata.ro differentiates them from competitors",
      advantage2: "42% won new clients or contracts due to adopting legal AI",
      advantage3: "77% cite AI when explaining their response speed and value offered to clients",
      advantage4: "39% easily deliver flat-rate contracts, eliminating uncertainty",
      advantage5: "52% confirm the platform expanded relations with existing clients",
      disappearTitle: "If the platform disappeared tomorrow...",
      disappearL1: "Major disruption — already integrated into daily workflow",
      disappearL2: "Manageable disruption — rebuilding would take time",
      disappearL3: "Uncomfortable — alternatives are inferior",
      disappearQuote: "\"It would be extremely disruptive; we have a response speed we can no longer sustain without AI. Certain types of mandates could no longer be accepted at flat rates.\"",
      disappearAuthor: "— Law firm partner, LegeaAplicata user"
    },
    features: {
      badge: "Platform",
      title: "What LegeaAplicata.ro Offers",
      sub: "A complete legal ecosystem, custom-built for the realities of the Romanian legal system",
      f1Title: "AI Jurisprudence",
      f1Desc: "Database with thousands of ICCJ, ECHR, and Romanian court rulings, with advanced semantic search",
      f2Title: "Comparative Analysis",
      f2Desc: "Parallel analysis of multiple rulings on the same topic, with automatic trend identification",
      f3Title: "Case Monitoring",
      f3Desc: "Automatic court case tracking, real-time notifications for hearings and updates",
      f4Title: "AI Legal Chat",
      f4Desc: "AI assistant specialized in Romanian legislation and case law, available 24/7",
      f5Title: "Company Creditworthiness",
      f5Desc: "Verification of the financial and legal status of commercial companies in Romania",
      f6Title: "Document Generation",
      f6Desc: "Semi-automatic generation of summons, contracts, and other standardized legal documents"
    },
    founder: {
      badge: "Founder's Vision",
      titleLine: "Why I Built ",
      titleHighlight: "LegeaAplicata.ro",
      quote: "\"My mission is to transform access to justice through technology. LegeaAplicata.ro is not just a database — it is a digital partner for every lawyer and litigant in Romania.\"",
      desc: "Combining legal education with advanced software engineering skills, Adrian Nicolau designed LegeaAplicata.ro as a technological research tool to eliminate hours of manual search through legislation and case law."
    },
    market: {
      badge: "Market Opportunity",
      title: "A vast, underserved market",
      card1: {
        label: "Active lawyers in Romania",
        sub: "Source: UNBR 2024"
      },
      card2: {
        label: "Legal advisors",
        sub: "Adjacent market"
      },
      card3: {
        label: "Magistrates and judges",
        sub: "Potential users"
      },
      card4: {
        label: "Romanian legal services market",
        sub: "Digitalization potential ≥ 30%"
      },
      growthTitle: "Growth Trajectory",
      growthDesc: "The global LegalTech sector is growing at ~22% CAGR. Romania, with a complex legal system and a well-trained community of practitioners, is a market with enormous potential — and LegeaAplicata.ro is already the reference platform.",
      growthP1: "First AI legal platform specialized in Romanian legislation",
      growthP2: "Organic growth through peer recommendations",
      growthP3: "Validated freemium → premium conversion model",
      growthP4: "Media presence and recognition in the legal community",
      penetrationLabel: "Current lawyer market penetration",
      penetrationSub: "Huge growth space — target 10% in 3 years",
      targetTitle: "2027 Target",
      targetL1: "active users",
      targetL2: "annual recurring revenue"
    },
    conclusion: {
      badge: "Conclusion",
      titleLine: "The future of legal practice ",
      titleHighlight: "is already here",
      desc1: "Productivity gains are the primary advantage of adopting legal AI, quickly followed by performance enhancements, quality increases, and revenue growth. The data shows that saved time increasingly translates into higher productivity and new business opportunities.",
      desc2: "For our clients, LegeaAplicata.ro is an essential part of their growth. If it disappeared, 81% would experience major or significant disruptions. That is the definition of a truly valuable solution.",
      stat1: "Faster response to clients",
      stat2: "Expanded capacity",
      stat3: "Positive client perception",
      stat4: "Transformational quality impact",
      ctaTitle: "Invest in the Future of Romanian Legal Tech",
      ctaDesc: "Discuss directly with the founding team about partnership, investment, or strategic collaboration opportunities.",
      ctaBtn: "Contact the Team"
    }
  },
  fr: {
    seo: {
      title: "Rapport ROI - Investissez dans l'avenir juridique roumain | LegeaAplicata",
      desc: "Découvrez l'impact mesurable de LegeaAplicata.ro : gains de productivité jusqu'à 94%, économies d'heures facturables, acquisition de nouveaux clients. La plateforme juridique IA n°1 en Roumanie.",
      keywords: "ROI juridique, investissement legaltech Roumanie, IA juridique roi, LegeaAplicata investisseurs, plateforme juridique IA, productivité des avocats, efficacité juridique",
      schemaTitle: "Rapport ROI - LegeaAplicata.ro",
      schemaDesc: "Rapport complet sur l'impact et le retour sur investissement dans la plateforme juridique LegeaAplicata.ro"
    },
    hero: {
      badge: "Rapport ROI 2025",
      line1: "Investir dans ",
      highlight1: "l'Intelligence",
      line2: "",
      highlight2: "Juridique",
      subtitle: "Comment LegeaAplicata.ro transforme la pratique juridique roumaine grâce à l'intelligence artificielle — avec des résultats mesurables.",
      subtitleFounder: "La plateforme technologique de recherche juridique en Roumanie, créée par Adrian Nicolau — fondateur et développeur de logiciels — pour optimiser la documentation en législation et jurisprudence.",
      btnContact: "Contactez-nous",
      btnResults: "Voir les Résultats"
    },
    intro: {
      badge: "Méthodologie",
      title: "À Propos de ce Rapport",
      desc1: "Ce rapport quantifie l'impact réel de LegeaAplicata.ro dans la pratique juridique roumaine, sur la base de données recueillies auprès de cabinets d'avocats, de bureaux de conseillers juridiques et d'institutions publiques utilisant la plateforme.",
      desc2: "Le secteur juridique subit sa transformation la plus profonde depuis une génération. Les premiers adoptants des outils d'IA constatent désormais des rendements tangibles — et les données de ce rapport fournissent un cadre crédible pour ce que les leaders du droit peuvent anticiper.",
      stat1Val: "200+",
      stat1Label: "Utilisateurs Actifs",
      stat1Sub: "Avocats, conseillers, magistrats",
      stat2Val: "8+",
      stat2Label: "Départements Couverts",
      stat2Sub: "Présence dans toute la Roumanie",
      stat3Val: "2024",
      stat3Label: "Fondée en",
      stat3Sub: "Plateforme en croissance continue"
    },
    finding1: {
      badge: "Constat Clé 1",
      title: "Impact sur les ",
      highlight: "Revenus",
      desc: "Les gains de productivité sont universels. Chaque utilisateur de la plateforme a signalé des avantages concrets et quantifiables.",
      mainStatPct: "94%",
      mainStatTitle: "Réponse plus rapide aux clients et partenaires",
      mainStatDesc: "Sur une échelle de 1 à 5, 94% des utilisateurs confirment qu'ils peuvent répondre aux demandes plus rapidement (4) ou beaucoup plus rapidement (5) en utilisant LegeaAplicata.ro. Les gains de productivité sont universels — chaque utilisateur peut fournir des exemples concrets d'affaires résolues plus efficacement.",
      examplesHeader: "Exemples Concrets",
      ex1: "Examen de 500 décisions de justice réduit de plusieurs semaines à quelques jours",
      ex2: "Recherche de jurisprudence pertinente : de 5h/jour à 30 minutes",
      ex3: "Génération du projet initial d'assignation en justice : 60% plus rapide",
      ex4: "Analyse comparative de 7 affaires similaires réalisée en quelques heures, pas en jours",
      statCard1: {
        label: "Capacité de travail élargie",
        sub: "Plus d'affaires dans le même laps de temps"
      },
      statCard2: {
        label: "Tâches prenant des heures → minutes",
        sub: "Gain de temps pour le travail facturable"
      },
      statCard3: {
        label: "Heures non facturables récupérées/semaine",
        sub: "Par utilisateur, en moyenne"
      },
      statCard4: {
        label: "Réduction des heures non facturables",
        sub: "Confirmé par les utilisateurs actifs"
      },
      calcTitle: "Calcul du Potentiel de Revenus Supplémentaires",
      calcSub: "Basé sur 4,3 heures récupérées par semaine et par juriste, au taux horaire moyen en Roumanie",
      calcCol1Title: "Heures récupérées/an par juriste",
      calcCol1Sub: "~198 (4,3h × 46 semaines)",
      calcCol2Title: "Taux horaire moyen avocat (RON)",
      calcCol2Sub: "400 (moyenne du marché roumain)",
      calcCol3Title: "Revenus supplémentaires potentiels/an par juriste",
      calcCol3Sub: "~79 200 RON (pour 100 juristes : ~7,9M RON/an)",
      calcFormula: "Formule ROI : Nombre de juristes × Heures économisées/semaine × Taux horaire × 46 semaines",
      whoBenefitsTitle: "Qui en bénéficie le plus ?",
      whoBenefitsL1: "Avocats avec expérience moyenne (2-7 ans)",
      whoBenefitsL2: "Avocats seniors / associés",
      whoBenefitsL3: "Juniors / stagiaires",
      whoBenefitsL4: "Associés / fondateurs",
      reallocTitle: "Comment le temps économisé est-il réalloué ?",
      reallocL1: "Analyse juridique à plus forte valeur ajoutée",
      reallocL2: "Interaction accrue avec les clients",
      reallocL3: "Travail facturable supplémentaire",
      reallocL4: "Développement de nouvelles affaires"
    },
    testimonials: {
      badge: "Voix des Clients",
      title: "Ce que disent les praticiens du droit",
      q1Text: "LegeaAplicata.ro a complètement changé ma façon de travailler. Ce qui me prenait autrefois une journée entière dans la bibliothèque de doctrine est maintenant résolu en 30 minutes. J'ai pu prendre deux dossiers de plus le mois dernier.",
      q1Author: "Me M. Ionescu",
      q1Role: "Avocat en droit civil, Bucarest",
      q2Text: "J'ai utilisé la plateforme pour une analyse comparative de 47 arrêts de la Haute Cour (ICCJ) sur le même sujet. La qualité de la synthèse par l'IA a dépassé toutes les attentes. Le client a été impressionné par la rapidité de réponse.",
      q2Author: "Me C. Popescu",
      q2Role: "Associé dans un cabinet d'avocats, Cluj-Napoca",
      q3Text: "En tant que juriste d'entreprise, je dois surveiller des dossiers dans tout le pays. LegeaAplicata.ro fait cela automatiquement et m'envoie des alertes. Je ne manque plus aucune échéance.",
      q3Author: "A. Dumitrescu, Conseiller Juridique",
      q3Role: "Conseiller juridique, Timisoara",
      q4Text: "L'outil de génération de documents m'a aidé à finaliser 3 contrats complexes en deux fois moins de temps. Les clients remarquent la rapidité et continuent de revenir.",
      q4Author: "Me R. Constantin",
      q4Role: "Cabinet indépendant, Iasi",
      q5Text: "Dans un cabinet de 8 avocats, l'adoption de LegeaAplicata.ro a apporté un gain de temps estimé à 35% par dossier. Nous avons pu refuser zéro dossier le mois dernier, contre 3 par mois auparavant.",
      q5Author: "Me D. Gheorghiu",
      q5Role: "Associé gérant, Brasov",
      q6Text: "La plateforme identifie des problèmes que j'aurais manqués autrement. Elle m'a aidé à gagner un dossier de droit du travail où l'argument clé était une disposition du Code fiscal que je n'avais pas associée à l'affaire.",
      q6Author: "Me L. Marin",
      q6Role: "Droit du travail et droit commercial"
    },
    finding2: {
      badge: "Constat Clé 2",
      title: "Impact sur la ",
      highlight: "Qualité",
      desc: "Au-delà de la productivité, l'IA juridique élève le niveau de qualité du travail et réduit le risque d'erreur humaine.",
      card1: {
        label: "Identifie des problèmes précédemment omis",
        desc: "L'IA détecte des aspects juridiques que les praticiens auraient pu omettre dans l'analyse manuelle"
      },
      card2: {
        label: "Plus grande confiance dans la qualité du travail",
        desc: "Les juristes déclarent se sentir plus confiants dans les avis et documents rédigés avec le soutien de l'IA"
      },
      card3: {
        label: "Impact majeur ou transformationnel sur la qualité",
        desc: "Réduction du risque d'erreurs, identification précoce des problèmes et gestion supérieure des risques"
      },
      talentBadge: "Élévation des Talents",
      talentTitle: "L'IA juridique amplifie la performance des meilleurs professionnels",
      talentDesc: "Pour les professionnels performants, LegeaAplicata.ro offre un avantage considérable. 65% des utilisateurs signalent une amélioration significative de leur performance personnelle. L'IA fonctionne mieux pour ceux qui savent déjà ce qu'il cherchent — et leur donne les ressources pour se développer.",
      talentQuote: "\"LegeaAplicata.ro est pour les avocats ce que Google Maps est pour les conducteurs — il ne remplace pas l'expertise, il la propulse.\"",
      talentL1: "Professionnels hautement performants",
      talentL2: "Amélioration globale de l'équipe",
      talentL3: "Rédaction plus claire et communication améliorée",
      talentL4: "Capacité d'analyse plus approfondie"
    },
    finding3: {
      badge: "Constat Clé 3",
      title: "Impact à ",
      highlight: "Long Terme",
      desc: "La valeur à long terme de l'IA juridique augmente à mesure que l'écosystème mûrit et que les connaissances institutionnelles se construisent.",
      card1: "61% - Impact majeur ou transformationnel dans le développement des compétences en IA",
      card2: "87% - Les clients les perçoivent plus positivement grâce à l'adoption d'une IA juridique moderne",
      card3: "55% - La plateforme a remplacé ou réduit le besoin d'autres outils",
      advantageTitle: "Avantage Concurrentiel",
      advantage1: "48% estiment que LegeaAplicata.ro les différencie de la concurrence",
      advantage2: "42% ont gagné de nouveaux clients ou contrats grâce à l'adoption de l'IA juridique",
      advantage3: "77% citent l'IA pour expliquer leur rapidité de réponse et la valeur offerte aux clients",
      advantage4: "39% livrent plus facilement des contrats à forfait, éliminant l'incertitude",
      advantage5: "52% confirment que la plateforme a élargi les relations avec les clients existants",
      disappearTitle: "Si la plateforme disparaissait demain...",
      disappearL1: "Perturbation majeure — déjà intégrée dans le flux de travail quotidien",
      disappearL2: "Perturbation gérable — la reconstruction prendrait du temps",
      disappearL3: "Inconfortable — les alternatives sont inférieures",
      disappearQuote: "\"Ce serait extrêmement perturbant ; nous avons une rapidité de réponse que nous ne pouvons plus maintenir sans IA. Certains types de mandats ne pourraient plus être acceptés à forfait.\"",
      disappearAuthor: "— Associé d'un cabinet d'avocats, utilisateur de LegeaAplicata"
    },
    features: {
      badge: "La Plateforme",
      title: "Ce que propose LegeaAplicata.ro",
      sub: "Un écosystème juridique complet, conçu sur mesure pour les réalités du système juridique roumain",
      f1Title: "Jurisprudence IA",
      f1Desc: "Base de données contenant des milliers de décisions de la Haute Cour (ICCJ), de la CEDH et des tribunaux roumains, avec recherche sémantique avancée",
      f2Title: "Analyse Comparative",
      f2Desc: "Analyse parallèle de plusieurs décisions sur le même sujet, avec identification automatique des tendances",
      f3Title: "Suivi des Dossiers",
      f3Desc: "Suivi automatique des dossiers judiciaires, notifications en temps réel pour les audiences et les mises à jour",
      f4Title: "Chat IA Juridique",
      f4Desc: "Assistant IA spécialisé dans la législation et la jurisprudence roumaines, disponible 24h/24 et 7j/7",
      f5Title: "Solvabilité des Entreprises",
      f5Desc: "Vérification de la situation financière et juridique des sociétés commerciales en Roumanie",
      f6Title: "Génération de Documents",
      f6Desc: "Génération semi-automatique d'assignations, de contrats et d'autres documents juridiques standardisés"
    },
    founder: {
      badge: "Vision du Fondateur",
      titleLine: "Pourquoi j'ai créé ",
      titleHighlight: "LegeaAplicata.ro",
      quote: "\"Ma mission is to transformer l'accès à la justice grâce à la technologie. LegeaAplicata.ro n'est pas seulement une base de données — c'est un partenaire numérique pour chaque avocat et justiciable en Roumanie.\"",
      desc: "Alliant des études juridiques à des compétences avancées en ingénierie logicielle, Adrian Nicolau a conçu LegeaAplicata.ro comme un outil de recherche technologique pour éliminer les heures de recherche manuelle dans la législation et la jurisprudence."
    },
    market: {
      badge: "Opportunité de Marché",
      title: "Un marché vaste et sous-desservi",
      card1: {
        label: "Avocats actifs en Roumanie",
        sub: "Source : UNBR 2024"
      },
      card2: {
        label: "Conseillers juridiques",
        sub: "Marché adjacent"
      },
      card3: {
        label: "Magistrats et juges",
        sub: "Utilisateurs potentiels"
      },
      card4: {
        label: "Marché des services juridiques RO",
        sub: "Potentiel de digitalisation ≥ 30%"
      },
      growthTitle: "Trajectoire de Croissance",
      growthDesc: "Le secteur mondial de la LegalTech croît à un TCAC de ~22%. La Roumanie, avec un système juridique complexe et une communauté de praticiens bien formés, est un marché au potentiel énorme — et LegeaAplicata.ro est déjà la plateforme de référence.",
      growthP1: "Première plateforme juridique IA spécialisée dans la législation roumaine",
      growthP2: "Croissance organique grâce aux recommandations entre pairs",
      growthP3: "Modèle de conversion freemium → premium validé",
      growthP4: "Présence médiatique et reconnaissance au sein de la communauté juridique",
      penetrationLabel: "Pénétration actuelle du marché des avocats",
      penetrationSub: "Espace de croissance énorme — cible de 10% en 3 ans",
      targetTitle: "Cible 2027",
      targetL1: "utilisateurs actifs",
      targetL2: "chiffre d'affaires annuel récurrent"
    },
    conclusion: {
      badge: "Conclusion",
      titleLine: "L'avenir de la pratique juridique ",
      titleHighlight: "est déjà présent",
      desc1: "Les gains de productivité sont le principal avantage de l'adoption de l'IA juridique, rapidement suivis par l'amélioration des performances, l'augmentation de la qualité et la croissance des revenus. Les données montrent que le temps économisé se traduit de plus en plus en une productivité accrue et de nouvelles opportunités d'affaires.",
      desc2: "Pour nos clients, LegeaAplicata.ro est un élément essentiel de leur croissance. S'il disparaissait, 81% subiraient des perturbations majeures ou significatives. C'est la définition même d'une solution véritablement précieuse.",
      stat1: "Réponse plus rapide aux clients",
      stat2: "Capacité élargie",
      stat3: "Perception positive des clients",
      stat4: "Impact transformationnel sur la qualité",
      ctaTitle: "Investissez dans l'avenir de la LegalTech roumaine",
      ctaDesc: "Discutiez directement avec l'équipe fondatrice des opportunités de partenariat, d'investissement ou de collaboration stratégique.",
      ctaBtn: "Contact l'Équipe"
    }
  }
};

export default roiTranslations;
